var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bgc-p bdr-4 p-10"},[_c('h1',{staticClass:"color-w pb-10"},[_vm._v("活动场馆")]),_c('div',{style:({ width: '20rem', height: '30rem', padding: '0 1rem', color: 'ffffff' }),attrs:{"id":"pie"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }